import React, { Component } from 'react';
import {c_shade_places as colors} from '../a-Graphic/Colors';
import {p_size_1, p_size_2, p_size_3, p_size_4} from '../a-Graphic/Layout';

import getMyMap, {createNamesLayer, createCommuneBordersLayer, getLegend, createPlacesLayer, createGriddedLayer} from '../b-LeafletMap/leaflet_map';

import LegendCommune from '../b-LeafletMap/Legend/LegendCommune';
import LegendPlace from '../b-LeafletMap/Legend/LegendPlace';
import LegendValues from '../b-LeafletMap/Legend/LegendValues';

class GriddedPopulation extends React.Component {

  componentDidMount() {
    /* COMMUNES */
    var communes = this.props.territory.communes;
    var communes_coords = communes.map((c) => c.center);
    var communes_names = communes.map((c) => c.name);

    /* GRIDDED POPULATION */
    var gridded_population = [].concat(...this.props.territory.communes.map((c)=>c.gridded_population));
    var pop_coords = gridded_population.map((c) => c.coords);
    var pop_masses = gridded_population.map((c) => c.population);
    var pop_labels = gridded_population.map((c) => c.population + " - hab");

    // --- init map
    var mymap = getMyMap(this.props.id, true, 0.3);

    // --- create layers
    var communes_layer = createCommuneBordersLayer(mymap, communes);
    createGriddedLayer(mymap, pop_coords, pop_masses, pop_labels);
    //createNamesLayer(mymap, communes_coords, communes_names);

    // --- center the map
    mymap.fitBounds(communes_layer.getBounds());
  }


  render() {
  var gridded_population = [].concat(...this.props.territory.communes.map((c)=>c.gridded_population));
  var pop_masses = gridded_population.map((c) => c.population);

    var [colors_legend, intervals] = getLegend(pop_masses);
    return(
          <div className="row align-items-end">
              <div className="col-2">
                   <LegendCommune label="(population)"/>
                   <p><b>Carreaux</b></p>
                   <LegendValues intervals={intervals} colors={colors_legend}/>
              </div>
              <div className="col-10">
                <div style={{height: "600px"}} id={this.props.id}></div>
              </div>
          </div>
    )
  }
}

export default GriddedPopulation;
